// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2tbZG","footer":"Form_footer__2YhGJ"};